export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11238.23cf8a94.jpg";